import { Link } from "react-router-dom";
import { latestAnime } from "@/mocks/animeData";
import AnimeCard from "@/components/feature/AnimeCard";

export default function LatestUpdates() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto w-full">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              每周更新，精彩不停歇
            </p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-400 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors hidden sm:flex items-center gap-1"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {latestAnime.map((anime, index) => (
            <div
              key={anime.id}
              className={`animate-fade-in-up ${
                index === 0
                  ? ""
                  : index === 1
                    ? "animation-delay-100"
                    : index === 2
                      ? "animation-delay-200"
                      : index === 3
                        ? "animation-delay-300"
                        : "animation-delay-400"
              }`}
            >
              <AnimeCard anime={anime} size="sm" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}